import keyMirror from 'keymirror';

export default keyMirror({
  SHOP_TITLE_RENDERED: null,
  NO_PRODUCTS_MESSAGE_RENDERED: null,
  PRODUCT_NOT_FOUND_MESSAGE_RENDERED: null,
  PRODUCT_QUANTITY: null,
  PRODUCT_NAME_RENDERED: null,
  PRODUCT_IMAGE_RENDERED: null,
  PRODUCT_CAROUSEL_RENDERED: null,
  PRODUCT_IMAGE_LOADER: null,
  PRODUCT_CARD_NAME_RENDERED: null,
  PRODUCT_PRICE_RENDERED: null,
  PRODUCT_SALE_PRICE_RENDERED: null,
  PRODUCT_EYEBROW_RENDERED: null,
  PRODUCT_FOOTER_RENDERED: null,
  PRODUCT_RIBBON_RENDERED: null,
  PRODUCT_SHIP_FREE_RENDERED: null,
  PRODUCT_LIMITED_EDITION_RENDERED: null,
  PRODUCT_FREE_RETURNS_RENDERED: null,
  PRODUCT_FREE_SHIPPING_AND_RETURNS_RENDERED: null,
  PRODUCT_DESCRIPTION_RENDERED: null,
  PRODUCT_GENERAL_ERROR: null,
  PRODUCT_ASSET_RENDERED: null,
  PRODUCT_ASSET_MOBILE_ZOOM_RENDERED: null,
  PRODUCT_ASSET_THUMBNAIL_RENDERED: null,
  PRODUCT_CAROUSEL_ASSET_RENDERED: null,
  PRODUCTS_VIEW_ALL: null,
  PRODUCT_LIST_RENDERED: null,
  PRODUCT_SORT_DROPDOWN: null,
  SEARCH_NO_RESULTS_MESSAGE_RENDERED: null,
  SIMILAR_PRODUCT_RENDERED: null,
  PRODUCT_LIST_MOBILE_RENDERED: null,
  PRODUCT_LIST_DESKTOP_RENDERED: null,
  PRODUCT_QUICK_VIEW_BUTTON_RENDERED: null,
  PRODUCT_QUICK_VIEW_MODAL_RENDERED: null,

  PRODUCT_STAR_RATING_RENDERED: null,
  PRODUCT_COLOR_SWATCHES_RENDERED: null,
  PRODUCT_REVIEWS_RENDERED: null,
  PRODUCT_FILES_RENDERED: null,

  PLACEHOLDER_PRODUCTS_TITLE: null,
  PLACEHOLDER_PRODUCTS_DESC: null,

  PROVISIONING_PLACEHOLDER: null,

  CART_TITLE_RENDERED: null,
  CART_ITEM_QUANTITY_RENDERED: null,
  ADD_TO_CART: null,
  BUY_NOW: null,
  PDP_APPLE_PAY: null,
  PDP_PAYMENT_REQUEST: null,
  PDP_POYNT_PAYMENT_REQUEST: null,
  CART_UPDATE: null,
  CART_CHECKOUT: null,
  CART_APPLE_PAY: null,
  CART_PAYMENT_REQUEST: null,
  CART_POYNT_PAYMENT_REQUEST: null,
  CART_REMOVE_LINK: null,
  CART_SUB_TOTAL: null,
  CART_EMPTY_TEXT: null,
  CART_LINE_ITEM_PRICE: null,
  CART_LINE_ITEM_TOTAL: null,
  OUT_OF_STOCK: null,
  REQUIRED_SELECT_FIELDS_BLANK: null,
  REQUIRED_TEXT_FIELDS_BLANK: null,
  LOW_INVENTORY_ALERT_RENDERED: null,
  BACKORDERED_ALERT_RENDERED: null,
  BACKORDERED_MESSAGE_RENDERED: null,
  PDP_SMART_RIBBON: null,

  DO_CHECKOUT_ID: null,

  VIDEO_IFRAME_RENDERED: null,

  PAGINATION_RENDERED: null,
  PAGINATION_PAGE_RANGE: null,
  PAGINATION_PAGE_NUMBER: null,
  PAGINATION_ARROW: null,

  SHOP_BTN_CREATE_PRODUCT_RENDERED: null,
  SHOP_BTN_IMPORT_PRODUCT_RENDERED: null,
  SHOP_RENDERED: null,

  TOGGLE_MOBILE_LIST: null,
  CATEGORY_LINK: null,
  CATEGORY_VIEW_ALL: null,

  COUPON_APPLY_BTN: null,
  COUPON_INPUT_FIELD: null,
  COUPON_MOBILE_FORM: null,
  COUPON_DESKTOP_FORM: null,

  SHOP_FETCHING_LOADER: null,
  SHOP_CATEGORIES: null,

  COVER_IMAGE_BACKGROUND: null,
  COVER_IMAGE_BANNER: null,
  COVER_IMAGE_HEADING: null,

  SOCIAL_SHARING_WRAPPER: null,
  SOCIAL_SHARING_FACEBOOK_ICON: null,
  SOCIAL_SHARING_TWITTER_ICON: null
});
